import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Rails CSRF token from the <meta> tag, for non-Inertia fetch() calls.
export function csrfToken(): string {
  return document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? ""
}

// Send JSON with the CSRF header — the app's standard raw-fetch helper, for
// requests that shouldn't navigate (Inertia's router covers the ones that do).
export function sendJson(method: "POST" | "PUT" | "PATCH" | "DELETE", url: string, body: unknown) {
  return fetch(url, {
    method,
    headers: { "Content-Type": "application/json", "X-CSRF-Token": csrfToken() },
    body: JSON.stringify(body),
  })
}

export function postJson(url: string, body: unknown) {
  return sendJson("POST", url, body)
}

// Domain acronyms that should display upper-cased instead of title-cased
// ("fbi_fingerprint" → "FBI Fingerprint", not "Fbi Fingerprint"). Keep in sync
// with config/initializers/inflections.rb (the Rails-side equivalent).
const ACRONYMS = new Set(["CDL", "CPR", "DOT", "FBI", "FMCSA", "SSN", "TB"])

// snake_case (or a single token) → "Title Case". The app's standard label
// humanizer for enum values, field kinds, statuses, etc. (Note: driver/Signing
// uses its own per-word capitalizer for already-spaced field labels.)
export function humanize(value: string): string {
  return value
    .split("_")
    .map((part) => {
      const upper = part.toUpperCase()
      if (ACRONYMS.has(upper)) return upper
      return part.charAt(0).toUpperCase() + part.slice(1)
    })
    .join(" ")
}
